export const topics = {
    M1: [
        { value: 'states_of_matter', label: 'State Changes' },
        { value: 'homogeneous_mixtures', label: 'Homogeneous Mixtures' },
        { value: 'heterogeneous_mixtures', label: 'Heterogeneous Mixtures' },
        { value: 'basic_separation', label: 'Filtration & Evaporation' },
        { value: 'advanced_separation', label: 'Distillation & Fractionation' },
        { value: 'mass_composition', label: 'Percentage Composition' },
        { value: 'ionic_naming', label: 'Nomenclature (Ionic)' },
        { value: 'covalent_naming', label: 'Nomenclature (Covalent)' },
        { value: 'protons_neutrons_electrons', label: 'Atomic Notation' },
        { value: 'nuclear_stability', label: 'Isotope Stability' },
        { value: 'radioisotope_applications', label: 'Radioisotope Uses' },
        { value: 'bohr_shells', label: 'Bohr Shell Model' },
        { value: 'quantum_subshells', label: 'Quantum Mechanics' },
        { value: 'aufbau_pauli_hunds', label: 'Orbital Filling' },
        { value: 'flame_tests', label: 'Flame Testing' },
        { value: 'emission_lines', label: 'Emission Spectra' },
        { value: 'valency_trends', label: 'Periodic Valency' },
        { value: 'electronegativity_trends', label: 'Electronegativity' },
        { value: 'ionisation_energy', label: 'Ionisation Energy' },
        { value: 'atomic_radii', label: 'Atomic Radius' },
        { value: 'electron_affinity', label: 'Electron Affinity' },
        { value: 'reactivity_trends', label: 'Metallic Character' },
        { value: 'periodic_table_trends', label: 'Periodic Table Trends' },
        { value: 'lewis_structures', label: 'Lewis Dot Diagrams' },
        { value: 'molecular_geometry', label: 'VSEPR Molecular Shapes' },
        { value: 'dipole_moments', label: 'Dipole Moments' },
        { value: 'h_bonding', label: 'Hydrogen Bonding' },
        { value: 'dipole_interactions', label: 'Dipole-Dipole Forces' },
        { value: 'dispersion_forces', label: 'Dispersion Forces' },
        { value: 'ionic_lattices', label: 'Ionic Networks' },
        { value: 'covalent_lattices', label: 'Covalent Networks' },
        { value: 'sea_of_electrons', label: 'Metallic Structure' }
    ],
    M2: [
        { value: 'balancing_reactions', label: 'Balancing Reactions' },
        { value: 'mole_concept', label: 'Mole Concept' },
        { value: 'avogadro_constant', label: 'Avogadro Constant' },
        { value: 'molar_mass', label: 'Molar Mass' },
        { value: 'formula_derivation', label: 'Empirical vs Molecular' },
        { value: 'mass_mass_stoichiometry', label: 'Stoichiometric Ratios' },
        { value: 'limiting_reactants', label: 'Limiting Reagents' },
        { value: 'yield_calculations', label: 'Percent Yield' },
        { value: 'atom_economy', label: 'Percent Atom Economy' },
        { value: 'concentration_molarity', label: 'Molarity Formulas' },
        { value: 'wv_percentage', label: 'Weight/Volume Percent' },
        { value: 'ppm_calculations', label: 'Parts Per Million' },
        { value: 'dilutions', label: 'Dilution Equation' },
        { value: 'primary_standards', label: 'Standard Solutions' },
        { value: 'combining_volumes', label: 'Gay-Lussac Gasses' },
        { value: 'pv_law', label: "Boyle's Law" },
        { value: 'vt_law', label: "Charles' Law" },
        { value: 'vn_law', label: 'Avogadro Gas Law' },
        { value: 'pv_nrt', label: 'Ideal Gas Law' },
        { value: 'stp_slc_volumes', label: 'Molar Volume Gas' }
    ],
    M3: [
        { value: 'synthesis', label: 'Synthesis Reaction' },
        { value: 'thermal_decomposition', label: 'Decomposition (Thermal)' },
        { value: 'electrolytic_decomposition', label: 'Decomposition (Electrolytic)' },
        { value: 'complete_combustion', label: 'Combustion (Complete)' },
        { value: 'incomplete_combustion', label: 'Combustion (Incomplete)' },
        { value: 'solubility_rules', label: 'Solubility Rules' },
        { value: 'spectator_ions', label: 'Net Ionic Equations' },
        { value: 'metal_acid_reactions', label: 'Metal-Acid Reactions' },
        { value: 'metal_water_reactions', label: 'Metal-Water Reactions' },
        { value: 'activity_series', label: 'Activity Series' },
        { value: 'redox_definitions', label: 'Oxidation-Reduction Def' },
        { value: 'oxidation_states', label: 'Oxidation Numbers' },
        { value: 'half_equations', label: 'Half Equations' },
        { value: 'anodic_oxidation', label: 'Galvanic Cell Anode' },
        { value: 'cathodic_reduction', label: 'Galvanic Cell Cathode' },
        { value: 'ion_migration', label: 'Salt Bridge Function' },
        { value: 'standard_potentials', label: 'Standard Potentials' },
        { value: 'collision_theory', label: 'Collision Theory' },
        { value: 'surface_area_rate', label: 'Surface Area Effect' },
        { value: 'concentration_rate', label: 'Concentration Effect' },
        { value: 'temperature_rate', label: 'Temperature Effect' },
        { value: 'catalyst_effect', label: 'Catalyst Effect' }
    ],
    M4: [
        { value: 'thermodynamic_systems', label: 'System & Surroundings' },
        { value: 'enthalpy_definition', label: 'Enthalpy' },
        { value: 'heat_capacity', label: 'Specific Heat Capacity' },
        { value: 'heat_of_solution', label: 'Calorimetry (Dissolution)' },
        { value: 'heat_of_combustion', label: 'Calorimetry (Combustion)' },
        { value: 'enthalpy_per_mole', label: 'Molar Enthalpy Calc' },
        { value: 'hess_law', label: 'Hess Law' },
        { value: 'bond_energy_sum', label: 'Bond Energy Sums' },
        { value: 'standard_enthalpy_formation', label: 'Formation Enthalpy' },
        { value: 'entropy', label: 'Entropy Definition' },
        { value: 'entropy_gas_evolution', label: 'Entropy Gas Evolution' },
        { value: 'gibbs_free_energy', label: 'Gibbs Free Energy' },
        { value: 'reaction_spontaneity', label: 'Spontaneity Prediction' },
        { value: 'temperature_dependent_spontaneity', label: 'Temperature Spontaneity' }
    ],
    M5: [
        { value: 'open_closed_systems', label: 'Open vs Closed Systems' },
        { value: 'reversibility', label: 'Reversibility' },
        { value: 'dynamic_equilibrium', label: 'Dynamic Equilibrium State' },
        { value: 'lcp_concentration', label: 'LCP (Concentration)' },
        { value: 'lcp_pressure', label: 'LCP (Pressure/Volume)' },
        { value: 'lcp_temperature', label: 'LCP (Temperature)' },
        { value: 'ea_equilibrium', label: 'Activation Energy Equilibrium' },
        { value: 'equilibrium_constant', label: 'Equilibrium Constant' },
        { value: 'reaction_quotient', label: 'Reaction Quotient Q' },
        { value: 'ice_table', label: 'ICE Table Calc' },
        { value: 'solubility_product', label: 'Solubility Product Ksp' },
        { value: 'solubility_calculations', label: 'Molar Solubility' },
        { value: 'common_ion_effect', label: 'Common Ion Effect' },
        { value: 'aboriginal_leaching', label: 'Aboriginal Leaching' }
    ],
    M6: [
        { value: 'ph_indicators', label: 'Indicator Ranges' },
        { value: 'naming_acids', label: 'Nomenclature (Acids)' },
        { value: 'arrhenius', label: 'Arrhenius Model' },
        { value: 'bronsted_lowry', label: 'Bronsted-Lowry Model' },
        { value: 'conjugates', label: 'Conjugate Acid-Base' },
        { value: 'amphiprotic_species', label: 'Amphiprotic Nature' },
        { value: 'log_ph', label: 'pH Scale & pOH' },
        { value: 'kw_water_ionisation', label: 'Kw Water Ionisation' },
        { value: 'complete_dissociation', label: 'Strong Acids/Bases' },
        { value: 'partial_dissociation', label: 'Weak Acids/Bases' },
        { value: 'acid_base_constants', label: 'Ka/Kb Constants' },
        { value: 'pka_pkb', label: 'pKa/pKb Relation' },
        { value: 'heat_of_neutralisation', label: 'Neutralisation Enthalpy' },
        { value: 'titration_equipment', label: 'Titration Equipment' },
        { value: 'titration_graphs', label: 'Titration Curves pH' },
        { value: 'equivalence_points', label: 'Equivalence Points' },
        { value: 'buffers', label: 'Buffers' }
    ],
    M7: [
        { value: 'organic_naming', label: 'IUPAC Naming Rules' },
        { value: 'isomers', label: 'Structural Isomers' },
        { value: 'hydrocarbon_trends', label: 'Hydrocarbon Properties' },
        { value: 'alkane_reactions', label: 'Alkanes Substitution' },
        { value: 'alkene_reactions', label: 'Alkenes Addition' },
        { value: 'alcohol_properties', label: 'Alcohol Physical Properties' },
        { value: 'alcohol_combustion', label: 'Alcohol Combustion' },
        { value: 'dehydration', label: 'Alcohol Dehydration' },
        { value: 'organic_oxidation', label: 'Alcohol Oxidation' },
        { value: 'fermentation', label: 'Fermentation Ethanol' },
        { value: 'organic_acid_properties', label: 'Carboxylic Acids Properties' },
        { value: 'esterification', label: 'Esters Preparation' },
        { value: 'organic_nitrogen_properties', label: 'Amines/Amides Properties' },
        { value: 'saponification_micelles', label: 'Soaps & Detergents' },
        { value: 'addition_polymers', label: 'Addition Polymers' },
        { value: 'condensation_polymers', label: 'Condensation Polymers' }
    ],
    M8: [
        { value: 'flame_tests', label: 'Cation Flame Tests' },
        { value: 'cation_wet_tests', label: 'Cation Precipitation' },
        { value: 'anion_wet_tests', label: 'Anion Analysis' },
        { value: 'uv_vis', label: 'UV-Vis Spectroscopy' },
        { value: 'aas', label: 'Atomic Absorption (AAS)' },
        { value: 'mass_spec', label: 'Mass Spectrometry Frags' },
        { value: 'ir', label: 'IR Spectroscopy Bonding' },
        { value: 'h_nmr', label: 'NMR Proton Shift' },
        { value: 'c13_nmr', label: 'NMR Carbon Shift' },
        { value: 'spin_spin_coupling', label: 'NMR Splitting Patterns' },
        { value: 'combined_spectral_analysis', label: 'Structural Deduction' },
        { value: 'synthesis_yield_purity', label: 'Chemical Synthesis Goals' },
        { value: 'reaction_pathways', label: 'Reaction Pathways' },
        { value: 'green_chem_design', label: 'Green Chemistry Principles' }
    ]
};

// Pre-computed lookup map for quick value -> label conversion
export const topicLabelMap = Object.values(topics)
    .flat()
    .reduce((map, topic) => {
        map[topic.value] = topic.label;
        return map;
    }, {});

export const getTopicLabel = (value) => {
    return topicLabelMap[value] || value.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
};
